import _classofRaw from "../internals/classof-raw";
import _functionUncurryThis from "../internals/function-uncurry-this";
var exports = {};
var classofRaw = _classofRaw;
var uncurryThis = _functionUncurryThis;
exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === "Function") return uncurryThis(fn);
};
export default exports;